import Block from "domain/Block";
import useUnscheduleDowntimeBlock from "hooks/apollo/downtimeBlock/useUnscheduleDowntimeBlock";
import useUnscheduleWorkBlock from "hooks/apollo/workBlock/useUnscheduleWorkBlock";

export default function useUnscheduleBlock() {
  const handleUnscheduleWorkBlock = useUnscheduleWorkBlock();
  const handleUnscheduleDowntimeBlock = useUnscheduleDowntimeBlock();

  return ({ block }) => {
    if (Block.isWorkBlock(block)) {
      return handleUnscheduleWorkBlock(block);
    }
    return handleUnscheduleDowntimeBlock(block);
  };
}
